import { render, staticRenderFns } from "./TeacherNewDialog.vue?vue&type=template&id=f67eff26&scoped=true"
import script from "./TeacherNewDialog.vue?vue&type=script&lang=js"
export * from "./TeacherNewDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherNewDialog.vue?vue&type=style&index=0&id=f67eff26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67eff26",
  null
  
)

export default component.exports